import React from 'react';
import {
  Alert, Button, LoadingButton, Typography, Drawer, DrawerHeader, DrawerBody, DrawerFooter, Card
} from '@one-thd/sui-atomic-components';
import { formatBrowser } from '../utils';

const REPORTDRAWER = {
  buttontext: 'Report',
  cancelText: 'Cancel',
  drawerText: 'Please confirm that the details below were not made by you.'

};
const SIGNOUTDRAWER = {
  buttontext: 'Yes, Sign Out Device',
  cancelText: 'No, Return to Security & Password',
  drawerText: 'Do you want to sign out the device associated with the suspicious activity?'

};

const ReportDrawer = (props) => {

  const {
    isOpen = false, onClose, selectedActivity = {}, region = '', country = '', os = '', browser = '', version = '', formattedDate, reportEvent, loadingButton = false, reportError
  } = props;

  const { eventTs, name, reportTs = '', smSessionId = '' } = selectedActivity || {};
  const formattedBrowser = formatBrowser(browser);

  const signoutVisible = smSessionId && reportTs;

  const textWeight = signoutVisible ? 'bold' : 'regular';
  const buttontext = signoutVisible ? SIGNOUTDRAWER.buttontext : REPORTDRAWER.buttontext;
  const cancelText = signoutVisible ? SIGNOUTDRAWER.cancelText : REPORTDRAWER.cancelText;
  const drawerText = signoutVisible ? SIGNOUTDRAWER.drawerText : REPORTDRAWER.drawerText;

  const getTitle = () => (<Typography variant="h4" height="none" data-testid="drawer-header">Report Activity</Typography>);

  return (
    <Drawer
      open={isOpen}
    >
      <DrawerHeader title={getTitle()} onClose={() => onClose()} />
      <DrawerBody>
        <div className="sui-flex sui-flex-col sui-gap-3">
          {reportTs
            ? (
              <Alert status="success" variant="subtle" size="small" data-testid="report-alert">
                Thank you for reporting this event - we will use this report to help keep your account secure.
              </Alert>
            ) : null}
          <Typography variant="body-base" height="tight" weight={textWeight}>
            {drawerText}
          </Typography>
          <Card>
            <div className="sui-flex sui-flex-col sui-gap-3">
              <div>
                <Typography variant="body-lg" weight="bold" height="tight">{name}</Typography>
                <Typography variant="body-base" height="tight">{formattedDate}</Typography>
              </div>
              <div>
                <Typography variant="body-lg" weight="bold" height="tight">Near</Typography>
                <Typography variant="body-base" height="tight">{`${region} ${country}`}</Typography>
              </div>
              <div>
                <Typography variant="body-lg" weight="bold" height="tight">Using</Typography>
                <Typography variant="body-base" height="tight">{`${os} ${version} ${formattedBrowser}`}</Typography>
              </div>
            </div>
          </Card>
          {reportError
            ? (
              <Alert status="error" variant="subtle" size="small">
                There was an error when processing your report. Please resubmit below.
              </Alert>
            ) : null}
        </div>
      </DrawerBody>
      <DrawerFooter>
        <div className="sui-flex sui-flex-col sui-gap-2">
          <LoadingButton variant="primary" fullWidth loading={loadingButton} data-testid={signoutVisible ? 'signout-button' : 'report-button'} onClick={() => reportEvent(eventTs)}>{buttontext}</LoadingButton>
          <Button variant="secondary" fullWidth onClick={() => onClose()}>{cancelText}</Button>
        </div>
      </DrawerFooter>
    </Drawer>
  );

};

export default ReportDrawer;
